/**
 * @ngdoc directive
 * @name footerpanel
 *
 * @description
 * Extended footer version
 */
module.directive('footerpanel', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', '$rootScope', 'drupal', '$filter', function ($scope, $rootScope, drupal, $filter) {
            $scope.config = $rootScope.config;

            /* Editorial : form */
            $scope.newsletter = {
                email : '',
                pending: false
            };

            $scope.newsletter.email = '';

            $scope.subscribe = function() {
                if ($scope.newsletterForm.$valid) {
                    $scope.newsletter.pending = true;
                    drupal.subsbribeNewletter($scope.newsletter.email).then(function() {
                        swal({
                          title: $filter('translate')('newsletter.title'),
                          text: $filter('translate')('newsletter.register_ok')
                        });
                        $scope.newsletter.email = '';
                    }).catch(function(error) {
                        swal({
                            title: $filter('translate')('server.notResponding'),
                            text: '',
                            icon: 'error'
                        });
                    }).finally(function () {
                        $scope.newsletter.pending = false;
                    });
                } else {
                    swal({
                        title: $filter('translate')('newsletter.title'),
                        text: $filter('translate')('form.invalidEmail'),
                        icon: 'error'
                    });
                }
            }
        }],
        templateUrl: 'src/components/footerpanel/footer.html'
    };
});
